export const justMultiSelcted = (oldValue, newValue) => {
  let returnval = false;
  if (Array.isArray(oldValue) && Array.isArray(newValue)) {
    oldValue.forEach((value, index) => {
      if (
        (value?.multiSelected === true &&
          newValue[index]?.multiSelected === false) ||
        (value?.multiSelected === false &&
          newValue[index]?.multiSelected === true)
      ) {
        returnval = true;
      } else {
        returnval = false;
      }
    });
  }
  return returnval;
};

export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

//sorting layers
export const orderLayersByZIndex = (layers = []) =>
  layers
    .map((layer, originalIndex) => ({
      layer,
      originalIndex,
      zIndex: Number(layer?.componentStyles?.zIndex),
    }))
    .sort((a, b) => {
      const aHasZIndex = Number.isFinite(a.zIndex);
      const bHasZIndex = Number.isFinite(b.zIndex);

      if (aHasZIndex && bHasZIndex && a.zIndex !== b.zIndex) {
        return b.zIndex - a.zIndex;
      }
      if (aHasZIndex !== bHasZIndex) {
        return aHasZIndex ? -1 : 1;
      }
      return a.originalIndex - b.originalIndex;
    })
    .map(({ layer }) => layer);

export const getMaxLayerNumber = (base, tempLayerData) => {
  const re = new RegExp(`^${base}(\\d+)$`);
  return (tempLayerData || []).reduce((max, item) => {
    const name =
      item?.componentStyles?.layerNameUpdated || item?.componentStyles?.layerName;
    const m = name && name.match(re);
    return m ? Math.max(max, Number(m[1])) : max;
  }, 0);
};

export const makeLayerNameAllocator = (getMaxLayerNumberForBase) => {
  const counters = {};
  return (base) => {
    if (counters[base] == null) counters[base] = getMaxLayerNumberForBase(base) + 1;
    return `${base}${counters[base]++}`;
  };
};

export const applyUniqueLayerNameIfDefaultText = (obj, alloc) => {
  if (!obj?.componentStyles) return;
  const ln = obj.componentStyles.layerName;
  const lnu = obj.componentStyles.layerNameUpdated;

  if (
    ln === "Text" ||
    lnu === "Text" ||
    /^Text\d+$/.test(ln) ||
    /^Text\d+$/.test(lnu)
  ) {
    const next = alloc("Text");
    obj.componentStyles.layerName = next;
    obj.componentStyles.layerNameUpdated = next;
  }
};

export const getSelectedListIdFromHtml = (html = "") => {
  if (typeof html !== "string") return "";
  const hasListItem = /<li(\s|>)/i.test(html);
  if (!hasListItem) return "";
  if (/<ul(\s|>)/i.test(html)) return 0;
  if (/<ol(\s|>)/i.test(html)) return 1;
  return "";
};

export const syncListSelectionState = (component) => {
  if (!component?.componentStyles) return;
  component.componentStyles.selectedIdnumberList = getSelectedListIdFromHtml(
    component.froalaText || "",
  );
};
